module.exports = __webpack_public_path__ + "media/images/digital-economy@2x-e436f5f50bfc257f9d1169272701beed.png";